import { LitElement } from 'lit';

import { PrintProofReviewDto, putUpdatePrintProofReview } from '@/api-sdk';

export const openPrintProofDialog = (element: LitElement) => {
  element.dispatchEvent(new CustomEvent('open-print-proof-dialog'));
};

export const handlePrintProofReview = async (
  uuid: string,
  reviewData: PrintProofReviewDto,
  element: LitElement,
  storeCode: string,
) => {
  try {
    await putUpdatePrintProofReview({
      uuid: uuid,
      data: reviewData,
      params: {
        storeCode,
      },
    });

    element.dispatchEvent(
      new CustomEvent('print-proof-review-submitted', { composed: true }),
    );
  } catch (error) {
    console.error(error);
  }
};
